module.exports = __webpack_public_path__ + "img/14.d363da98.png";